import { render, staticRenderFns } from "./ReportItems.vue?vue&type=template&id=af4d221e&scoped=true&"
import script from "./ReportItems.vue?vue&type=script&lang=js&"
export * from "./ReportItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4d221e",
  null
  
)

export default component.exports